<!--
voice组件的使用说明
  1> 在需要的组件引入voice： import voice from '@/components/voice/index'
  2> 注册组件
  3> 使用组件 <voice />
-->

<template>
  <div class="main"
       @click.self="close">
    <div class="send-barrage">
      <ul>
        <li
          v-for='(item, index) in barrageTypes'
          :key="item.id"
          :class="index==typeIndex?'selected':''"
          @click="handleChangType(item.id, index)">{{item.name}}</li>
      </ul>
      <div class="content-wrap">
        <div v-for='(item, index) in contentArr'
             :key='index'
             :class="selectIndex==index?'item selected':'item'"
             @click="selectMessage(index)">
          {{item.name}}
        </div>
      </div>
      <div class="bless-step-con">
        <textarea rows="4"
                  maxLength=30
                  :placeholder="placeholderText"
                  @blur="blur"
                  @focus="focus"
                  @input="textInput"
                  v-model="message"></textarea>
        <div class="operate-wrap">
          <div class="clear" @click="() => this.message=''">清空</div>
          <div class="num">{{message.length}}/{{30}}</div>
        </div>
      </div>
      <div class="send-btn"
           @click='send'>
           <img src="./static/btn.png" alt=""></div>
    </div>
  </div>
</template>

<script>
import {
  apis,
  chttp,
} from '@/libs/interfaces';
import { mapState } from 'vuex';

export default {
  name: '',
  data() {
    return {
      selectIndex: 0,
      placeholderText: '大屏幕上飘过，大家都看得到~',
      contentArr: [],
      message: '',
      isloading: false,
      barrageTypes: [],
      typeIndex: 0,
    };
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      show_barrage: (state) => state.show_barrage,
      is_vip: (state) => state.is_vip,
      ad_src: (state) => state.ad_src,
    }),
  },
  created() {
    this.$store.dispatch('getData', {
      keyName: 'barrage',
      callback: (res) => {
        this.barrageTypes = res.data;
        this.getBarrages(res.data[0].id);
      },
    });
  },
  methods: {
    handleChangType(id, index) {
      this.typeIndex = index;
      this.selectIndex = 0;
      this.getBarrages(id);
    },
    getBarrages(id) {
      this.$store.dispatch('getData', {
        keyName: `barrage_sort${id}`,
        callback: (res) => {
          this.contentArr = res.data;
          this.message = res.data[0].name;
        },
      });
    },
    close() {
      this.$store.commit('SHOW_BARRAGE', false);
    },
    selectMessage(index) {
      this.selectIndex = index;
      this.message = this.contentArr[index].name;
    },
    focus() {
      this.placeholderText = '';
    },
    blur() {
      if (this.message.length === 0) {
        this.placeholderText = '大屏幕上飘过，大家都看得到~';
      }
    },
    textInput() {
      const reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/;
      if (reg.test(this.message)) {
        this.$store.commit('SHOW_ALERT_MODAL', '暂不支持表情输入');
        this.message = this.message.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
      }
    },
    send() {
      if (this.isloading) {
        return;
      }
      if (this.message.trim()) {
        const data = {
          openid: this.openid,
          unionid: this.unionid,
          content_text: this.message,
        };
        this.isloading = true;
        chttp.post(apis.sendBarrage, data).then(() => {
          this.$toast('发送成功,请看大屏幕');
          this.$sendLog({
            event_type: 'click',
            event_name: '发送上屏成功',
            event_data: {
              page: '发弹幕',
              message: this.message,
            },
          });
          this.message = '';
          this.selectIndex = null;
          this.isloading = false;
        }).catch(() => {
          this.$toast('发送失败');
          this.isloading = false;
        });
      } else {
        this.$toast('请填写内容');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  z-index: $z_index_two;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  .bkg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    animation: backOpacity 0.5s;
  }
  .send-barrage {
    width: 100%;
    height: 600px;
    position: absolute;
    left: 0;
    bottom: 112px;
    background: #fff;
  }
  .send-btn {
    width: 413px;
    margin: 10px auto 0;
  }
  .bless-step-con {
    position: relative;
    height: 188px;
    overflow: hidden;
    margin: 12px auto 0;
    width: 670px;
    .operate-wrap {
      display: flex;
      position: absolute;
      bottom: 20px;
      right: 19px;
      align-items: center;
      div {
        line-height: 45px;
      }
      .num {
        width: 95px;
        font-size: 32px;
        color: $three_level_color;
        text-align: right;
      }
      .clear {
        font-size: 28px;
        color: $one_level_color;
      }
    }
    textarea {
      width: 670px;
      height: 188px;
      background: #F8F8FA;
      border-radius: 15px;
      font-size: 32px;
      color: $one_level_color;
      padding: 23px 30px;
    }
  }
  ul {
    display: flex;
    align-items: center;
    font-size: 30px;
    color: $three_level_color;
    padding-left: 38px;
    padding-top: 20px;
    margin-bottom: 46px;
    li {
      width: 80px;
      text-align: center;
      margin-right: 45px;
      position: relative;
      cursor: pointer;
    }
    .selected {
      font-size: 34px;
      color: $one_level_color;
      font-weight:500;
      &:after {
        content: "";
        width: 40px;
        height: 8px;
        background: $one_level_color;
        border-radius:6px;
        left: 50%;
        margin-left: -20px;
        bottom: -14px;
        position: absolute;
      }
    }
  }
  .content-wrap {
    padding: 0 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    text-align: center;
    .item {
      width: 320px;
      height: 46px;
      line-height: 46px;
      border:2px solid rgba(153,126,255,1);
      border-radius:23px;
      color: #997EFF;
      font-size: 26px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      padding: 0 7px;
      margin-bottom: 20px;
    }
    .selected {
      background: #997EFF;
      color: #fff;
    }
  }
}
</style>
